import { render, staticRenderFns } from "./CartHead.vue?vue&type=template&id=0f00b974&"
import script from "./CartHead.vue?vue&type=script&lang=js&"
export * from "./CartHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports